import React from "react";
export const ellipse = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "4", height: "4", viewBox: "0 0 4 4", fill: "none" },
    React.createElement("circle", { cx: "2", cy: "2", r: "2", fill: "#878787", fillOpacity: "0.35" })));
